export type IcTextFieldTypes =
  | "email"
  | "password"
  | "tel"
  | "text"
  | "url"
  | "number"
  | "search";

export type IcTextFieldInputModes =
  | "none"
  | "text"
  | "tel"
  | "url"
  | "email"
  | "numeric"
  | "decimal"
  | "search";

export type IcAriaAutocompleteTypes = "inline" | "list" | undefined;

export interface IcTextFieldKeydownEventDetail {
  event: KeyboardEvent;
  cursorPosition: number;
  selectionEnd: number;
}
